/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Row, Col, Spin } from 'antd';

import { Collapse, ErrorMessage, List } from '@atoms';
import { Pagination } from '@molecules';
import { pluralize } from '@utils';
import { useSet } from '@hooks';
import { usePostsList } from '@api/hooks';

import PostItem from './PostItem';

const PostsList = ({ pagination, parentId, parentType, liveBlogId }) => {
  const [, editingPosts] = useSet();
  const { posts, error, isFetching, isLoading } = usePostsList(
    {
      /**
       * If parentId would be null or undefined it won't be passed to API as url param and
       * API will return all posts. This is just a safety measure to avoid false sense of
       * everything is working when parentId is not passed or lost
       */
      parentId: parentId || 'none',
      parentType,
      perPage: pagination.perPage,
      page: pagination.page,
      liveBlogId,
    },
    {
      onSuccess: (response) => {
        editingPosts.reset();
        pagination.setTotal(response.total);
      },
    },
  );

  return (
    <Collapse>
      <Collapse.Panel header="Previous posts" note={isLoading ? 'loading...' : pluralize(pagination.total, 'post')}>
        <ErrorMessage error={error} />
        <Spin spinning={isFetching}>
          <List
            dataSource={posts.data}
            renderItem={(post) => (
              <PostItem
                post={post}
                parentId={parentId}
                parentType={parentType}
                isEditing={editingPosts.has(post)}
                toggleEdit={editingPosts.toggle}
                liveBlogId={liveBlogId}
              />
            )}
          />
          <Row justify="center" style={{ paddingTop: 15 }}>
            <Col>
              <Pagination
                current={pagination.page}
                pageSize={pagination.perPage}
                total={pagination.total}
                onChange={pagination.handleChange}
              />
            </Col>
          </Row>
        </Spin>
      </Collapse.Panel>
    </Collapse>
  );
};

export default PostsList;
